import Vue from 'vue'
import state from 'lib/appState'

Vue.component('header-search-icon', {
  data () {
    return {
      state,
      init: false
    }
  },
  methods: {
    toggleSearchOverlay () {
      if (!this.init) return false
      this.state.activeDrawer = this.state.activeDrawer ? null : 'header-search'
      this.state.modalToggleEl = document.activeElement
    }
  },
  watch: {
    'state.activeDrawer': function () {
      window.Searchanise.$(document).off('Searchanise.DataRequestEnd')
      window.Searchanise.$(document).on('Searchanise.DataRequestEnd', (event, type, data, results) => {
        this.state.searchAttributes = data
        this.state.searchResults = results
      })

      setTimeout(() => {
        window.Searchanise.Start()
      }, 1000)
    }
  },
  mounted () {
    const checker = setInterval(() => {
      this.init = window.Searchanise
      if (this.init) {
        clearInterval(checker)
      }
    }, 500)
  }
})
